import { useState, useEffect } from 'react';

// example found at:
//  https://dev.to/gabe_ragland/debouncing-with-react-hooks-jci

// this hook returns once for every string of updates to
// {value} occuring within {delay} ms of one another
export default function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
